<template>
  <div>
    <el-button type="danger" icon="el-icon-plus" @click="dialogVisible = true"
      >添加净流入/流出</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="添加净流入/流出"
      @close="closeDialog"
    >
      <el-form :model="data" ref="form" :rules="rules" label-width="80px">
        <el-form-item label="币种" prop="coinType">
          <el-select v-if="coinTypes.length" v-model="data.coinType">
            <el-option v-for="coin in coinTypes" :key="coin" :value="coin">{{
              coin
            }}</el-option>
          </el-select>
          <coin-select
            v-else
            :coinType="data.coinType"
            @value="(val) => (data.coinType = val)"
          />
        </el-form-item>
        <el-form-item label="用户" prop="userId">
          <el-select v-if="userIds.length" v-model="data.userId">
            <el-option
              v-for="userId in userIds"
              :key="userId"
              :value="userId"
              >{{ userId }}</el-option
            >
          </el-select>
          <el-input v-else v-model="data.userId"></el-input>
        </el-form-item>
        <el-form-item label="方向" prop="direction">
          <el-select v-model="data.direction">
            <el-option label="流入" value="in">流入</el-option>
            <el-option label="流出" value="out">流出</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数额" prop="amount">
          <el-input-number v-model="data.amount"></el-input-number>
        </el-form-item>
        <el-form-item
          label="时间"
          prop="time"
        >
          <el-date-picker
            v-model="data.time"
            type="datetime"
            :placeholder="'请选择' + (data.direction === 'in' ? '流入' : '流出') + '时间'"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button @click="submit" :loading="submitting" type="primary"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import CoinSelect from "../../../../components/coinSelect";

export default {
  name: "CreateFlow",
  props: ["coinTypes", "userIds"],
  data() {
    return {
      dialogVisible: false,
      submitting: false,
      data: {
        direction: "in",
        amount: "",
        userId: "",
        coinType: "",
        time: "",
      },
      rules: {
        coinType: [{ required: true, message: "币种不能为空！" }],
        userId: [{ required: true, message: "用户ID不能为空！" }],
        amount: [{ required: true, message: "数量不能为空！" }],
        time: [{ required: true, message: "时间不能为空！" }],
      },
    };
  },
  components: {
    CoinSelect,
  },
  computed: {},
  methods: {
    ...mapActions("snapshotStatistic", ["createFlow"]),
    closeDialog() {
      this.dialogVisible = false;
      this.data = {
        direction: 'in'
      };
      this.$refs["form"].resetFields();
    },
    submit() {
      if (this.submitting) return;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.submitting = true;
          this.createFlow({
            userId: this.data.userId,
            coinType: this.data.coinType,
            amount:
              this.data.direction === "in"
                ? this.data.amount
                : -this.data.amount,
            time: this.data.time && this.data.time.getTime(),
          })
            .then(() => {
              this.closeDialog();
              this.$emit("onChange");
            })
            .finally(() => {
              this.submitting = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>
